/* In the event that local storage is full,
use session storage as a fallback */
const setStartTime = (nameOfTimer: string, startTime: string): void => {
  try {
    localStorage.setItem(nameOfTimer, startTime);
  } catch {}
  try {
    sessionStorage.setItem(nameOfTimer, startTime);
  } catch {}
};

const getStartTime = (nameOfTimer: string): number => {
  let sessionValue = 0;
  let localValue = 0;
  try {
    sessionValue = Number(sessionStorage.getItem(nameOfTimer));
  } catch {}
  try {
    localValue = Number(localStorage.getItem(nameOfTimer));
  } catch {}
  return sessionValue || localValue || new Date().getTime();
};

const removeStartTime = (nameOfTimer: string): void => {
  try {
    localStorage.removeItem(nameOfTimer);
  } catch {}
  try {
    sessionStorage.removeItem(nameOfTimer);
  } catch {}
};

const calculateTimeSpentInMilliseconds = (nameOfTimer: string): number => {
  const startTime = getStartTime(nameOfTimer);
  return new Date().getTime() - startTime;
};

export {
  setStartTime,
  getStartTime,
  calculateTimeSpentInMilliseconds,
  removeStartTime,
};
